import React from 'react'
import './Articles.css'
import Articles1 from './Articles1'
import Content from './Content'
import { useState } from 'react'
import ContentManager from './ContentManager'

var Contentdetails = [
    {id:'1',h1:'Content 1',p1:'Content 1',imgUrl:"https://res.cloudinary.com/di1jyuoqd/image/upload/v1683485783/SEC_logo_3b_1_cvebkm.png"},
    {id:'2',h1:'Content 2',p1:'Content 2',imgUrl:"https://res.cloudinary.com/di1jyuoqd/image/upload/v1683485783/SEC_logo_3b_1_cvebkm.png"},
    {id:'3',h1:'Content 3',p1:'Content 3',imgUrl:"https://res.cloudinary.com/di1jyuoqd/image/upload/v1683485783/SEC_logo_3b_1_cvebkm.png"},
    {id:'4',h1:'Content 4',p1:'Content 4',imgUrl:"https://res.cloudinary.com/di1jyuoqd/image/upload/v1683485783/SEC_logo_3b_1_cvebkm.png"},
    {id:'5',h1:'Content 5',p1:'Content 5',imgUrl:"https://res.cloudinary.com/di1jyuoqd/image/upload/v1683485783/SEC_logo_3b_1_cvebkm.png"},
    {id:'6',h1:'Content 6',p1:'Content 6',imgUrl:"https://res.cloudinary.com/di1jyuoqd/image/upload/v1683485783/SEC_logo_3b_1_cvebkm.png"},
    {id:'7',h1:'Content 7',p1:'Content 7',imgUrl:"https://res.cloudinary.com/di1jyuoqd/image/upload/v1683485783/SEC_logo_3b_1_cvebkm.png"},
    {id:'8',h1:'Content 8',p1:'Content 8',imgUrl:"https://res.cloudinary.com/di1jyuoqd/image/upload/v1683485783/SEC_logo_3b_1_cvebkm.png"},
]
export default function Articles() {


    return (
        <>
        <div className='articles'>
          <ContentManager Contentdetails={Contentdetails} preview={1}/>
          </div>
        </>
    )
}
